<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver">
    <div class="iq-card-body ">
      <b-form @submit.prevent="handleSubmit(submit)" ref="FloorForm">
        <div class="iq-card-header ">
          <div class="iq-header-title d-flex justify-content-between">
            <h4 class="card-title">
              {{ pageTitle }}
            </h4>
            <div v-if="pageTitle === 'Edit Floor'">
              <b-button
                variant="primary"
                @click="$emit('showAddChanged', !showAdd)"
                ><i class="ion-plus"></i
              ></b-button>
            </div>
          </div>
        </div>

        <FormGenerator
          :Fields="fields"
          :model="formData"
          :options="options"
          globalClass="w-100"
        />
        <div>
          <b-spinner
            v-if="loading"
            variant="primary"
            label="Spinning"
          ></b-spinner>
          <button v-else type="submit" class="btn btn-primary">
            {{ buttonName }}
          </button>
        </div>
      </b-form>
    </div>
  </ValidationObserver>
</template>
<script>
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import { Fields, options, models } from "./form_fields";
import { getFloorData } from "@/API/FloorsAPIs";
export default {
  name: "Form",
  components: {
    FormGenerator
  },
  props: [
    "id",
    "pageTitle",
    "buttonName",
    "isInList",
    "model",
    "branchId",
    "businessId",
    "isCreateMode",
    "loading",
    "showAdd"
  ],
  data() {
    return {
      formData: JSON.parse(JSON.stringify(models)),
      options,
      fields: Fields,
      emptyModel: null
    };
  },
  async created() {
    await this.loadData();
  },
  async mounted() {
    this.emptyModel = models;
    this.formData.branchId = this.branchId;
    this.formData.businessId = this.businessId;
  },
  watch: {
    async id(val) {
      if (this.id) this.formData = await getFloorData(val);
    },
    model: {
      deep: true,
      handler(value) {
        this.formData = { ...this.formData, ...value };
      }
    },
    branchId(val) {
      this.formData.branchId = val;
    },
    businessId(val) {
      this.formData.businessId = val;
    }
  },
  methods: {
    submit() {
      this.formData.businessId = this.businessId;
      this.$emit("submit", {
        ...this.formData,
        businessId: this.formData.businessId,
        branchId: this.formData.branchId
      });
    },
    resetForm() {
      if (this.emptyModel) {
        this.formData = JSON.parse(JSON.stringify(this.emptyModel));
        this.formData.branchId = this.branchId;
        this.formData.businessId = this.businessId;
        this.$refs.validationObserver && this.$refs.validationObserver.reset();
      } else {
        console.error("emptyModel is not defined");
      }
    },
    async loadData() {
      if (!this.id) this.id = this.$route.params.id;
      if (this.id)
        this.formData = await getFloorData({
          businessId: this.formData.businessId,
          branchId: this.formData.branchId,
          id: this.id
        });
      if (this.model) this.formData = { ...this.model };
      if (this.createForm) {
      }
    }
  }
};
</script>
<style scoped></style>
